export const demos = [
{
    "key": "agency-drupal-8",
    "title": "agency-drupal-8",
    "description": "",
    "thumb": "images/Agency.png",
    "released_date": "07 January 2019",
    "package": "drupal-themes/agency",
    "demo": "agency",
    "link": "#agency-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$55",
    "buyLink": "https://www.weebpal.com/drupal-themes/agency",
    "domain": "https://agency.demo.weebpal.com/"
  },
 {
    "key": "furniture-drupal-8",
    "title": "furniture-drupal-8",
    "description": "",
    "thumb": "images/furniture.jpg",
    "released_date": "06 December 2018",
    "package": "drupal-themes/new-furniture",
    "demo": "new-furniture",
    "link": "#new-furniture-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$55",
    "buyLink": "https://www.weebpal.com/drupal-themes/new-furniture",
    "domain": "http://new-furniture.demo.weebpal.com/"
  },
  {
    "key": "language-drupal-7",
    "title": "language-drupal-7",
    "description": "",
    "thumb": "images/language.png",
    "released_date": "23 September 2018",
    "package": "drupal-themes/language",
    "demo": "language",
    "link": "#language-drupal-7",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$63",
    "buyLink": "https://www.weebpal.com/drupal-themes/language",
    "domain": "http://language-d7.demo.weebpal.com/"
  },
  {
    "key": "koolkids-drupal-8",
    "title": "koolkids-drupal-8",
    "description": "",
    "thumb": "images/koolkids.png",
    "released_date": "20 September 2018",
    "package": "drupal-themes/koolkids",
    "demo": "koolkids",
    "link": "#koolkids-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$59",
    "buyLink": "https://www.weebpal.com/drupal-themes/koolkids",
    "domain": "http://koolkids.demo.weebpal.com/"
  },
  {
    "key": "norwood-drupal8",
    "title": "Norwood Drupal 8",
    "description": "",
    "thumb": "images/norwood.jpg",
    "released_date": "20 September 2018",
    "package": "drupal-themes/norwood",
    "demo": "furniture",
    "link": "#furniture-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$59",
    "buyLink": "https://www.weebpal.com/drupal-themes/norwood",
    "domain": "http://furniture.demo.weebpal.com/"
  },
  {
    "key": "construction-drupal8",
    "title": "Construction Drupal 8",
    "description": "",
    "thumb": "images/construction 960 460.png",
    "released_date": "20 January 2018",
    "package": "drupal-themes/construction",
    "demo": "construction",
    "link": "#construction-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$59",
    "buyLink": "https://www.weebpal.com/drupal-themes/construction",
    "domain": "http://construction.demo.weebpal.com/"
  },
  {
    "key": "electro-sound-drupal8",
    "title": "Electro Sound Drupal 8",
    "description": "",
    "thumb": "images/music.png",
    "released_date": "17 June 2018",
    "package": "drupal-themes/electro-sound",
    "demo": "electro-sound",
    "link": "#electro-sound-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$59",
    "buyLink": "https://www.weebpal.com/drupal-themes/electro-sound",
    "domain": "http://electro-sound.demo.weebpal.com/"
  },
  {
    "key": "job-board-drupal8",
    "title": "Job Board Drupal 8",
    "description": "",
    "thumb": "images/job-board.png",
    "released_date": "17 January 2018",
    "package": "drupal-themes/jobboard",
    "demo": "jobboard",
    "link": "#jobboard-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$63",
    "buyLink": "https://www.weebpal.com/drupal-themes/jobboard",
    "domain": "http://jobboard.demo.weebpal.com/"
  },
  {
    "key": "xcrystal-drupal-8",
    "title": "Xcrystal Drupal 8",
    "description": "",
    "thumb": "images/xcrystal.jpg",
    "released_date": "17 January 2018",
    "package": "drupal-themes/xcrystal-game-addict-drupal-8-theme",
    "demo": "games",
    "link": "#xcrystal-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$59",
    "buyLink": "https://www.weebpal.com/drupal-themes/xcrystal-game-addict-drupal-8-theme",
    "domain": "http://games.demo.weebpal.com"
  },
  {
    "key": "brainfood-drupal-8",
    "title": "Brainfood Drupal 8",
    "description": "",
    "thumb": "images/brainfood.jpg",
    "released_date": "15 March 2018",
    "package": "drupal-themes/brainfood",
    "demo": "brainfood",
    "link": "#brainfood-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$63",
    "buyLink": "https://www.weebpal.com/drupal-themes/brainfood",
    "domain": "http://brainfood.demo.weebpal.com"
  },
  {
    "key": "gloriosa-drupal-8",
    "title": "Gloriosa Drupal 8",
    "description": "",
    "thumb": "images/gloriosa.jpg",
    "released_date": "08 December 2017",
    "package": "drupal-themes/gloriosa-hotel-resort-drupal-8-themes",
    "demo": "gloriosa",
    "link": "#gloriosa-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$59",
    "buyLink": "https://www.weebpal.com/drupal-themes/gloriosa-hotel-resort-drupal-8-themes",
    "domain": "http://gloriosa.demo.weebpal.com"
  },
  {
    "key": "zetraz-drupal-8",
    "title": "Zetraz Drupal 8",
    "description": "",
    "thumb": "images/zetraz.jpg",
    "released_date": "08 March 2017",
    "package": "drupal-themes/zetraz-news-press-drupal-8-theme",
    "demo": "zetraz",
    "link": "#zetraz-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$68",
    "buyLink": "https://www.weebpal.com/drupal-themes/zetraz-news-press-drupal-8-theme",
    "domain": "http://zetraz.demo.weebpal.com"
  },
  {
    "key": "lapurd-drupal-8",
    "title": "Lapurd Drupal 8",
    "description": "",
    "thumb": "images/lapurd.jpg",
    "released_date": "26 July 2016",
    "package": "drupal-themes/lapurd-responsive-multi-purpose-drupal-8-theme",
    "demo": "lapurd",
    "link": "#lapurd-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$55",
    "buyLink": "https://www.weebpal.com/drupal-themes/lapurd-responsive-multi-purpose-drupal-8-theme",
    "domain": "http://lapurd.demo.weebpal.com"
  },
  {
    "key": "autox-drupal-8",
    "title": "Autox Drupal 8",
    "description": "",
    "thumb": "images/autoX_d8.jpg",
    "released_date": "24 May 2016",
    "package": "drupal-themes/autox-d8-responsive-cars-showroom-drupal-8-theme",
    "demo": "autox",
    "link": "#autox-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$66",
    "buyLink": "https://www.weebpal.com/drupal-themes/autox-d8-responsive-cars-showroom-drupal-8-theme",
    "domain": "http://autox.demo.weebpal.com"
  },
  {
    "key": "magazine-drupal-8",
    "title": "Magazine for Drupal 8",
    "description": "",
    "thumb": "images/magazine.jpg",
    "released_date": "23 Aug 2014",
    "package": "drupal-themes/magazine-d8-responsive-news-magazine-drupal-8-theme",
    "demo": "magazine",
    "link": "#magazine-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$66",
    "buyLink": "https://www.weebpal.com/drupal-themes/magazine-d8-responsive-news-magazine-drupal-8-theme",
    "domain": "http://magazine.demo.weebpal.com"
  },
  {
    "key": "marketplace-drupal-8",
    "title": "Marketplace for Drupal 8",
    "description": "",
    "thumb": "images/marketplace.jpg",
    "released_date": "23 Aug 2014",
    "package": "drupal-themes/marketplace-d8-responsive-ecommerce-drupal-8-theme",
    "demo": "marketplace",
    "link": "#marketplace-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$63",
    "buyLink": "https://www.weebpal.com/drupal-themes/marketplace-d8-responsive-ecommerce-drupal-8-theme",
    "domain": "http://marketplace.demo.weebpal.com"
  },
  {
    "key": "forum-plus-drupal-8",
    "title": "Forum Plus for Drupal 8",
    "description": "",
    "thumb": "images/forum-plus.jpg",
    "released_date": "23 Aug 2014",
    "package": "drupal-themes/forum-plus-d8-responsive-drupal-8-forum-theme",
    "demo": "forum-plus",
    "link": "#forum-plus-drupal-8",
    "type": "premium",
    "download_title": "DOWNLOAD",
    "class": "",
    "price": "",
    "buyLink": "http://weebpal.com/contrib/forum-plus-d8",
    "domain": "http://forum-plus.demo.weebpal.com"
  },
  {
    "key": "onepage-drupal-8",
    "title": "One Page for Drupal 8",
    "description": "",
    "thumb": "images/onepage.jpg",
    "released_date": "10 Oct 2015",
    "package": "drupal-themes/onepage-d8-responsive-multipurpose-drupal-8-theme",
    "demo": "onepage",
    "link": "#onepage-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$55",
    "buyLink": "https://www.weebpal.com/drupal-themes/onepage-d8-responsive-multipurpose-drupal-8-theme",
    "domain": "http://onepage.demo.weebpal.com"
  },
  {
    "key": "business-drupal-8",
    "title": "Business Drupal 8",
    "description": "",
    "thumb": "images/business_d8.jpg",
    "released_date": "28 August 2015",
    "package": "drupal-themes/business-d8-responsive-corporate-drupal-8-theme",
    "demo": "business",
    "link": "#business-d8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$55",
    "buyLink": "https://www.weebpal.com/drupal-themes/business-d8-responsive-corporate-drupal-8-theme",
    "domain": "http://business.demo.weebpal.com"
  },
  {
    "key": "pinteros-drupal-8",
    "title": "Pinteros for Drupal 8",
    "description": "",
    "thumb": "images/pinteros.jpg",
    "released_date": "15 Jul 2014",
    "package": "drupal-themes/pinteros-d8-responsive-freestyle-drupal-8-theme",
    "demo": "pinteros",
    "link": "#pinteros-drupal-8",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$55",
    "buyLink": "https://www.weebpal.com/drupal-themes/pinteros-d8-responsive-freestyle-drupal-8-theme",
    "domain": "http://pinteros.demo.weebpal.com"
  },
  {
    "key": "zircon-drupal-8",
    "title": "Zircon Drupal 8",
    "name": "zircon-drupal-8",
    "description": "",
    "thumb": "images/zircon.jpg",
    "released_date": "16 May 2014",
    "package": "sites/default/files/packages/zircon_profile-8.x-1.0-beta11.zip&nid=819",
    "demo": "zircon",
    "link": "#zircon-drupal-8",
    "type": "free",
    "download_title": "BUY NOW",
    "class": "",
    "price": "",
    "buyLink": "http://weebpal.com/drupal-themes/zircon-responsive-drupal-8-theme",
    "domain": "http://zircon.demo.weebpal.com"
  },
  {
    "key": "blog_theme",
    "title": "Blog Theme for Drupal 8",
    "name": "Blog Theme for Drupal 8",
    "description": "",
    "thumb": "images/blog_theme.jpg",
    "released_date": "16 Jun 2014",
    "package": "sites/default/files/packages/blog_theme.zip&nid=862",
    "demo": "blog_theme",
    "link": "#blog_theme",
    "type": "free",
    "download_title": "BUY NOW",
    "class": "",
    "price": "",
    "buyLink": "http://weebpal.com/drupal-themes/personal-blog-theme-drupal-8",
    "domain": "http://blog-theme.demo.weebpal.com"
  },
  {
    "key": "sushi-bar",
    "title": "Chappie sushibar",
    "description": "",
    "thumb": "images/sushibar.jpg",
    "released_date": "22 Septemper 2015",
    "package": "drupal-themes/chappie-sushi-bar-responsive-restaurant-bar-theme",
    "demo": "sushi-bar",
    "link": "#sushi-bar",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$53",
    "buyLink": "https://www.weebpal.com/drupal-themes/chappie-sushi-bar-responsive-restaurant-bar-theme",
    "domain": "http://sushi-bar-d7.demo.weebpal.com"
  },
  {
    "key": "cupcake",
    "title": "Chappie cupcake",
    "description": "",
    "thumb": "images/cupcake.jpg",
    "released_date": "29 May 2015",
    "package": "drupal-themes/chappie-cupcake-food-and-recipe-drupal-theme",
    "demo": "cupcake",
    "link": "#cupcake",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$53",
    "buyLink": "https://www.weebpal.com/drupal-themes/chappie-cupcake-food-and-recipe-drupal-theme",
    "domain": "http://cupcake-d7.demo.weebpal.com"
  },
  {
    "key": "chappie",
    "title": "Chappie",
    "description": "",
    "thumb": "images/chappie.jpg",
    "released_date": "29 May 2015",
    "package": "drupal-themes/chappie-responsive-restaurant-bistro-drupal-theme",
    "demo": "chappie",
    "link": "#chappie",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$53",
    "buyLink": "https://www.weebpal.com/drupal-themes/chappie-responsive-restaurant-bistro-drupal-theme",
    "domain": "http://chappie-d7.demo.weebpal.com/"
  },
  {
    "key": "photo",
    "title": "Photo",
    "description": "",
    "thumb": "images/photo.jpg",
    "released_date": "29 May 2015",
    "package": "drupal-themes/photos-creative-responsive-photo-drupal-theme",
    "demo": "photo",
    "link": "#photo",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "New release",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/photos-creative-responsive-photo-drupal-theme",
    "domain": "http://photo-d7.demo.weebpal.com"
  },
  {
    "key": "educational",
    "title": "Educational",
    "description": "",
    "thumb": "images/educational.jpg",
    "released_date": "10 Jul 2014",
    "package": "drupal-themes/educational-responsive-education-training-drupal-theme",
    "demo": "educational",
    "link": "#educational",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/educational-responsive-education-training-drupal-theme",
    "domain": "http://educational-d7.demo.weebpal.com"
  },
  {
    "key": "marvel",
    "title": "Marvel",
    "description": "",
    "thumb": "images/marvel.jpg",
    "released_date": "10 Jul 2014",
    "package": "drupal-themes/marvel-multipurpose-ecommerce-drupal-themes-rtl",
    "demo": "marvel",
    "link": "#marvel",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$58",
    "buyLink": "http://weebpal.com/drupal-themes/marvel-multipurpose-ecommerce-drupal-themes-rtl-support",
    "domain": "http://marvel-d7.demo.weebpal.com"
  },
  {
    "key": "marketplace",
    "title": "Marketplace",
    "description": "",
    "thumb": "images/marketplace.jpg",
    "released_date": "10 Jul 2014",
    "package": "drupal-themes/marketplace-responsive-ecommerce-drupal-theme",
    "demo": "marketplace",
    "link": "#marketplace",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$63",
    "buyLink": "https://www.weebpal.com/drupal-themes/marvel-multipurpose-ecommerce-drupal-themes-rtl",
    "domain": "http://marketplace-d7.demo.weebpal.com"
  },
  {
    "key": "events",
    "title": "Events",
    "description": "",
    "thumb": "images/events.jpg",
    "released_date": "10 Jul 2014",
    "package": "drupal-themes/eventive-event-and-online-booking-drupal-theme",
    "demo": "events",
    "link": "#events",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$53",
    "buyLink": "https://www.weebpal.com/drupal-themes/eventive-event-and-online-booking-drupal-theme",
    "domain": "http://events-d7.demo.weebpal.com"
  },
  {
    "key": "real_estast",
    "title": "Real Estast",
    "description": "",
    "thumb": "images/real_estast.jpg",
    "released_date": "10 Jul 2014",
    "package": "drupal-themes/realestast-real-estate-business-drupal-theme",
    "demo": "real_estast",
    "link": "#real_estast",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$53",
    "buyLink": "https://www.weebpal.com/drupal-themes/realestast-real-estate-business-drupal-theme",
    "domain": "http://real-estast-d7.demo.weebpal.com/"
  },
  {
    "key": "flatize",
    "title": "Flatize",
    "description": "",
    "thumb": "images/flatize.jpg",
    "released_date": "10 Jul 2014",
    "package": "drupal-themes/flatize-shopping-ecommerce-drupal-theme",
    "demo": "flatize",
    "link": "#flatize",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$58",
    "buyLink": "https://www.weebpal.com/drupal-themes/flatize-shopping-ecommerce-drupal-theme",
    "domain": "http://flatize-d7.demo.weebpal.com"
  },
  {
    "key": "hermio",
    "title": "Hermio",
    "description": "",
    "thumb": "images/hermio.jpg",
    "released_date": "01 Oct 2014",
    "package": "drupal-themes/hermio",
    "demo": "hermio",
    "link": "#hermio",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/hermio",
    "domain": "http://hermio-d7.demo.weebpal.com"
  },
  {
    "key": "aloha",
    "title": "Aloha",
    "description": "",
    "thumb": "images/aloha.jpg",
    "released_date": "03 Oct 2014",
    "package": "drupal-themes/aloha",
    "demo": "aloha",
    "link": "#aloha",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$59",
    "buyLink": "https://www.weebpal.com/drupal-themes/aloha",
    "domain": "http://aloha-d7.demo.weebpal.com"
  },
  {
    "key": "forum-plus",
    "title": "Forum Plus",
    "description": "",
    "thumb": "images/forum-plus.jpg",
    "released_date": "23 Aug 2014",
    "package": "drupal-themes/forum-plus-responsive-drupal-forum-theme",
    "demo": "forum-plus",
    "link": "#forum-plus",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/forum-plus-responsive-drupal-forum-theme",
    "domain": "http://forum-plus-d7.demo.weebpal.com"
  },
  {
    "key": "autox",
    "title": "AutoX",
    "description": "",
    "thumb": "images/autox.jpg",
    "released_date": "22 Aug 2014",
    "package": "drupal-themes/autox",
    "demo": "autox",
    "link": "#autox",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/autox",
    "domain": "http://autox-d7.demo.weebpal.com"
  },
  {
    "key": "pinteros",
    "title": "Pinteros",
    "description": "",
    "thumb": "images/pinteros.jpg",
    "released_date": "15 Jul 2014",
    "package": "drupal-themes/pinteros",
    "demo": "pinteros",
    "link": "#pinteros",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/pinteros",
    "domain": "http://pinteros-d7.demo.weebpal.com"
  },
  {
    "key": "magazine",
    "title": "Magazine",
    "description": "",
    "thumb": "images/magazine.jpg",
    "released_date": "09 May 2014",
    "package": "drupal-themes/magazine",
    "demo": "magazine",
    "link": "#magazine",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$59",
    "buyLink": "https://www.weebpal.com/drupal-themes/magazine",
    "domain": "http://magazine-d7.demo.weebpal.com"
  },
  {
    "key": "business",
    "title": "Business",
    "description": "",
    "thumb": "images/business.jpg",
    "released_date": "26 Apr 2014",
    "package": "drupal-themes/business",
    "demo": "business",
    "link": "#business",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/business",
    "domain": "http://business-d7.demo.weebpal.com"
  },
  {
    "key": "real-estate",
    "title": "Real Estate",
    "description": "",
    "thumb": "images/real-estate.jpg",
    "released_date": "12 Apr 2014",
    "package": "drupal-themes/real-estate",
    "demo": "real-estate",
    "link": "#real-estate",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/real-estate",
    "domain": "http://real-estate-d7.demo.weebpal.com"
  },
  {
    "key": "new-shopping",
    "title": "New Shopping",
    "description": "",
    "thumb": "images/new-shopping.jpg",
    "released_date": "26 Jan 2014",
    "package": "drupal-themes/new-shopping",
    "demo": "new-shopping",
    "link": "#new-shopping",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/new-shopping",
    "domain": "http://new-shopping-d7.demo.weebpal.com"
  },
  {
    "key": "onepage",
    "title": "One Page",
    "description": "",
    "thumb": "images/onepage.jpg",
    "released_date": "4 Nov 2013",
    "package": "drupal-themes/one-page",
    "demo": "onepage",
    "link": "#onepage",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/one-page",
    "domain": "http://onepage-d7.demo.weebpal.com"
  },
  {
    "key": "garnet",
    "title": "Garnet",
    "description": "",
    "thumb": "images/garnet.jpg",
    "released_date": "28 Jul 2013",
    "package": "drupal-themes/garnet",
    "demo": "garnet",
    "link": "#garnet",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/garnet",
    "domain": "http://garnet-d7.demo.weebpal.com"
  },
  {
    "key": "zircon_ii",
    "title": "Zircon II",
    "description": "",
    "thumb": "images/zircon_ii.jpg",
    "released_date": "11 May 2013",
    "package": "drupal-themes/zircon-ii",
    "demo": "zircon_ii",
    "link": "#zircon_ii",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/zircon-ii",
    "domain": "http://zircon-ii-d7.demo.weebpal.com"
  },
  {
    "key": "news",
    "title": "News",
    "description": "",
    "thumb": "images/news.jpg",
    "released_date": "11 May 2013",
    "package": "drupal-themes/news",
    "demo": "news",
    "link": "#news",
    "type": "premium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/news",
    "domain": "http://news-d7.demo.weebpal.com"
  },
  {
    "key": "personal-blog",
    "title": "Personal Blog",
    "description": "",
    "thumb": "images/blog.jpg",
    "released_date": "28 Feb, 2013",
    "package": "drupal-themes/personal-blog",
    "demo": "personal-blog",
    "link": "#personal-blog",
    "type": "fremium",
    "download_title": "BUY NOW",
    "class": "",
    "price": "$49",
    "buyLink": "https://www.weebpal.com/drupal-themes/personal-blog",
    "domain": "http://personal-blog-d7.demo.weebpal.com"
  },
  {
    "key": "hotel",
    "title": "Hotel",
    "description": "",
    "thumb": "images/hotel.jpg",
    "released_date": "31 Aug 2012",
    "package": "sites/default/files/packages/hotel.zip",
    "demo": "hotel",
    "link": "#hotel",
    "type": "free",
    "download_title": "DOWNLOAD",
    "class": "",
    "price": "",
    "buyLink": "http://weebpal.com/drupal-themes/hotel",
    "domain": "http://hotel-d7.demo.weebpal.com"
  },
  {
    "key": "corporate",
    "title": "Corporate",
    "description": "",
    "thumb": "images/corporate.jpg",
    "released_date": "09 Dec 2012",
    "package": "sites/default/files/packages/corporate-site.zip",
    "demo": "corporate-site",
    "link": "#corporate",
    "type": "free",
    "download_title": "DOWNLOAD",
    "class": "",
    "price": "",
    "buyLink": "http://weebpal.com/drupal-themes/corporate-site",
    "domain": "http://corporate-site-d7.demo.weebpal.com"
  },
  {
    "key": "education",
    "title": "Education",
    "description": "",
    "thumb": "images/education.jpg",
    "released_date": "30 Nov 2012",
    "package": "sites/default/files/packages/education.zip",
    "demo": "education",
    "link": "#education",
    "type": "free",
    "download_title": "DOWNLOAD",
    "class": "",
    "price": "",
    "buyLink": "http://weebpal.com/drupal-themes/education",
    "domain": "http://education-d7.demo.weebpal.com"
  },
  {
    "key": "ishopping",
    "title": "iShopping",
    "description": "",
    "thumb": "images/ishopping.jpg",
    "released_date": "31 Aug 2012",
    "package": "sites/default/files/packages/ishopping.zip",
    "demo": "ishopping",
    "link": "#ishopping",
    "type": "free",
    "download_title": "DOWNLOAD",
    "class": "",
    "price": "",
    "buyLink": "http://weebpal.com/drupal-themes/ishopping",
    "domain": "http://ishopping-d7.demo.weebpal.com"
  },
  {
    "key": "zircon",
    "title": "zircon",
    "description": "",
    "thumb": "images/zircon_d7.jpg",
    "released_date": "28 Aug 2012",
    "package": "http://ftp.drupal.org/files/projects/zircon_profile-7.x-1.0-beta3.zip",
    "demo": "zircon",
    "link": "#zircon",
    "type": "free",
    "download_title": "DOWNLOAD",
    "class": "",
    "price": "",
    "buyLink": "http://weebpal.com/drupal-themes/zircon",
    "domain": "http://zircon-d7.demo.weebpal.com"
  }
];


// WEBPACK FOOTER //
// ./src/data.js